import { ReactNode } from "react";
import css from "./supertitle.module.scss";

export enum SuperTitleStyle {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

interface ISuperTitleProps {
  children: ReactNode;
  className?: string;
  style?: SuperTitleStyle;
}

const SuperTitle = (props: ISuperTitleProps) => {
  const { children, className, style = SuperTitleStyle.PRIMARY } = props;

  return (
    <span className={`${css.superTitle} ${className} ${css[style]}`}>
      {children}
    </span>
  );
};

export default SuperTitle;
